import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CharacterCreator from "./pages/AddCharacterForm";
import { AuthProvider } from "./contexts/AuthContext";
import BookList from "./pages/BookList";
import CharacterList from "./pages/CharacterList";
import CharacterDetail from "./pages/CharacterDetail";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Feed from "./pages/Feed";
import { useEffect, useState } from "react";
import Loading from './Loading';
import { useNavigationType, useLocation } from 'react-router-dom';
import { setupAxiosInterceptors } from "./lib/api";

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const loadingStartTime = useRef<number | null>(null);
  const MIN_LOADING_TIME = 1000; // minimum 1 second

  useEffect(() => {
    // On route change or manual loading trigger, start loading
    setLoading(true);
    loadingStartTime.current = Date.now();

    // Simulate async loading finishing after some delay
    const timeout = setTimeout(() => {
      // Calculate elapsed time
      const elapsed = Date.now() - (loadingStartTime.current ?? 0);
      const remainingTime = MIN_LOADING_TIME - elapsed;

      if (remainingTime > 0) {
        setTimeout(() => setLoading(false), remainingTime);
      } else {
        setLoading(false);
      }
    }, 500); // here 500ms is your async event or axios call time simulation

    return () => clearTimeout(timeout);
  }, [location]);

  // useEffect(() => {
  //   setupAxiosInterceptors(setLoading);
  // }, []);

  return (
    <AuthProvider>
      {loading && <Loading />}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/charactercreator" element={<CharacterCreator />} />
          <Route path="/booklist" element={<BookList />} />
          <Route path="/characterlist" element={<CharacterList />} />
          <Route path="/characters/:id" element={<CharacterDetail />} />
          <Route path="/feed" element={<Feed />} />
        </Route>
      </Routes>
      <ToastContainer />
    </AuthProvider>
  );
}

export default App;
